// extracted by mini-css-extract-plugin
export default {"VersionList":"VersionList_VersionList__BKPqW","SegmentedContent":"VersionList_SegmentedContent__W4ZvA","new":"VersionList_new__lk7V7"};